import { useState, useEffect } from 'react';
import { IonModal, IonIcon, IonImg, IonText } from '@ionic/react';
import { close } from 'ionicons/icons';
import { Constants } from '../../../defines/Constants';
import { CleanHTML } from '../../../defines/Functions';
import axios from "axios";
import Loading from '../../Loading';
import './ResultsCustomText.css';
import warningSign from '../../../assets/images/warning.svg';

interface Props {
    data: any
}
const ResultsCustomText = (props: Props) => {
    const resultsCustomTextApi = Constants.api.resultsCustomText;
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        showResultsCustomTextModal: false,
        resultsCustomTexts: '',
        errorMessage: ''
    });
    useEffect(() => {
        const getResultsCustomText = async () => {
            setLoading(true);
            try {
                const results = await axios.post(resultsCustomTextApi, { from_code: props.data.fromCode, to_code: props.data.toCode }, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                });
                if (results.data.status === 'success') {
                    setState({ ...state, resultsCustomTexts: results.data.results_custom_texts_items[0].text });
                    setLoading(false);
                }
            } catch (error) {
                console.log(error);
                setState({ ...state, errorMessage: 'خطا در برقراری ارتباط با وب سرویس' });
                setLoading(false);
            }
        }
        if (state.showResultsCustomTextModal) {
            getResultsCustomText();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resultsCustomTextApi, state.showResultsCustomTextModal]);
    return (
        <>
            <IonModal isOpen={state.showResultsCustomTextModal} onDidDismiss={() => setState({ ...state, showResultsCustomTextModal: false })} mode="ios" cssClass="results-custom-text-modal">
                <div className="results-custom-text-modal-content">
                    <h3 className="results-custom-text-modal-title">
                        خدمات تور
                        <IonIcon icon={close} onClick={() => setState({ ...state, showResultsCustomTextModal: false })} />
                    </h3>
                    <div className="results-custom-text-modal-items">
                        {!loading ?
                            state.errorMessage.trim().length !== 0 ?
                                <div className="box-error ion-margin">
                                    <IonImg src={warningSign} />
                                    <p>{state.errorMessage}</p>
                                </div>
                                :
                                <p className="ion-text-justify">
                                    {CleanHTML(state.resultsCustomTexts)}
                                </p>
                            :
                            <Loading />
                        }
                    </div>
                </div>
            </IonModal>
            <IonText className="results-custom-text-btn" onClick={() => setState({ ...state, showResultsCustomTextModal: true })}>
                خدمات تور
            </IonText>
        </>
    );
};
export default ResultsCustomText;